import { Col, Row } from "antd";
import CodeSyntaxHighlighter from "../../../../../component/syntax-highlighter";

const html = `<html lang="en">
  <head>
      <link rel="stylesheet" 
        href="https://cdn.jsdelivr.net/npm/@waxio/widget-marketplace@latest/build/main.css">
      <script 
        src="https://cdn.jsdelivr.net/npm/@waxio/widget-marketplace@latest/build/main.js"></script>
  </head>

  <body>
      <wax-marketplace collections='your-collections-name'/>
  </body>
</html>`;

export default function InstallByHtml() {
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p className="w-font-md fw-600 color-text-secondary">
              1. Place embed in the body of your HTML
            </p>
          </Col>
          <Col xs={24}>
            <CodeSyntaxHighlighter code={html} />
          </Col>
        </Row>
      </Col>
      <Col xs={24}>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <p className="w-font-md fw-600 color-text-secondary">2. Done!</p>
          </Col>
          <Col xs={24}>
            <Row className="box-embed" gutter={[0, 12]}>
              <Col xs={24}>
                <Row align="middle" gutter={[8, 0]}>
                  <Col>
                    <img src="icon/warn.svg" alt="warn" />
                  </Col>
                  <Col>
                    <p className="color-warn w-font-sm fw-600">
                      Iframes are not supported
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col xs={24}>
                <p style={{ color: "#777E90" }} className="w-font-sm fw-600">
                  Use of iframes is not supported as it has security concerns.
                  We are working on other ways to embed.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
